import { defineFieldFormInterface } from "~/entities/field";
import InterfaceInputMultilineTextType from "./InterfaceInputMultilineTextType.vue";

export default defineFieldFormInterface({
  interface: "input-multiline",
  type: "text",
  component: InterfaceInputMultilineTextType,
});
